let config = {
  QiYuKey: 18 // 订单中心 七鱼客服所需参数，区分业务，用于 @xes/public-head-foot
}

const prodConfig = {
  appid: 1003085,
  appkey: '5ee6b5152998c6b52674be88de868bf8'
}

const devConfig = {
  appid: 1002943,
  appkey: 'aa6a78bf2f12cce3dd50f639821d91e5'
}

// 手动修改配置
Object.assign(config, prodConfig) // 测试环境使用
// Object.assign(config, devConfig) // 灰度、线上使用

export default config



// WEBPACK FOOTER //
// ./module/order/src/config.js